export default __webpack_public_path__ + "check-circle.svg";